import React, { useState } from 'react'
import AddNewAdvanceDirectives from './AddNewAdvanceDirectives';

const AdvanceDirectives = ({expandAll, data, setIsRecordSaved, ...props}) => {

  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenAdvanceDirectives, setIsOpenAdvanceDirectives] = useState(false);
  const [advanceDirectivesID, setAdvanceDirectivesID] = useState();
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddAdvanceDirectives = (ID) => {
    if(!isViewAllowed) return;
    setAdvanceDirectivesID(ID)
    setIsOpenAdvanceDirectives(prev => !prev);
  }
  const CloseAdvanceDirectives = () => {
    setIsOpenAdvanceDirectives(false)
  }

  let PopupScreen = "";
  if (isOpenAdvanceDirectives) {
      PopupScreen = <AddNewAdvanceDirectives isOpenAdvanceDirectives={isOpenAdvanceDirectives} advanceDirectivesID={advanceDirectivesID} setIsRecordSaved={setIsRecordSaved} setAdvanceDirectivesID={setAdvanceDirectivesID} onClose={CloseAdvanceDirectives} patientID={props?.patientID} // onDeleteAdvanceDirectives={DeleteAdvanceDirectives} 
      IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
      />
  }
  return (
    <>
    {PopupScreen}
    <div className='content-box '>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1'>
            <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Advance Directives</p>
            <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddAdvanceDirectives(null)}></i>
        </div>
        {expandItems &&
          expandAll &&
        <div className="d-flex flex-column gap-2">
        {(data?.length > 0 ?
          <>
          {data.map(item => {
            return (
              <div className='ar-dot'>
                  <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddAdvanceDirectives(item.PatientAdvanceDirectivesID)}>{item.Notes}</p>
              </div>
          )})}
          </> :
        <div className="d-flex gap-1 align-items-center ">
        </div>
        )}
      </div>}
    </div>
    </>
  )
}

export default AdvanceDirectives